import { bridge, env } from '@changba/funny'
import qs from 'qs'

function splitWithQuestion(text) {
  const firstQuestionMarkIndex = text.indexOf('?')
  if (firstQuestionMarkIndex !== -1) {
    const firstPart = text.substring(0, firstQuestionMarkIndex)
    const secondPart = text.substring(firstQuestionMarkIndex + 1)

    return [firstPart, secondPart]
  }
  return []
}

// 是否是鸿蒙
export const isHarmonyOS = () => {
  if (env?.browser?.isHarmonyOS) {
    return true
  }
  const ua = navigator.userAgent.toLowerCase()
  return /OpenHarmony/i.test(ua) || /ArkWeb/i.test(ua)
}

/* 打开新的容器，处理参数 */
export function gotoWebView(str, $router, direct = false) {

  // 如果是鸿蒙并且是微信链接,用openWebview打开
  if (str.includes('wx.tenpay.com') && isHarmonyOS()) {
      bridge.openWebView(str, {})
      return
  }

  if (direct) {
    window.location.href = str
    return
  }
  const questionArr = splitWithQuestion(str)
  console.log('questionArr', questionArr)
  setTimeout(() => {
    $router.replace({
      path: '/orders'
    })
  }, 1000)
  bridge.openWebView(questionArr[0], qs.parse(questionArr[1]))
}
